<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content *ngIf="!isPageLoading">

    <h1 class="header">Edit Employee
        <mat-icon class="margin-left" (click)="openModal()">delete_forever</mat-icon>
    </h1>
    <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="submitForm()" #form="ngForm">
        <table>
            <tr>
                <th id="first-name">First Name:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="firstName" [(ngModel)]="employee.firstName" name="firstName"
                               [value]="employee.firstName" required/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="last-name">Last Name:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="lastName" [(ngModel)]="employee.lastName" name="lastName"
                               [value]="employee.lastName" required/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="email">Email:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="emailAddress" [(ngModel)]="employee.emailAddress" name="emailAddress"
                               [value]="employee.emailAddress" required/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="contract-type">Contract Type:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <mat-label>Contract Type:</mat-label>
                        <select matNativeControl [(ngModel)]="employee.contractType" name="contract" required>
                            <option *ngFor="let contract of contractTypes" [value]="contract.value">
                                {{contract.displayValue}}
                            </option>
                        </select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="region-header">Region:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput id="region" [readonly]="employee.region" name="region"
                               [value]="employee.region" required/>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="team-header">Team:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <select matNativeControl [(ngModel)]="employee.teamId" name="team" id="team" required>
                            <option *ngFor="let team of teamData" [value]="team.id">
                                {{team.teamName}}
                            </option>
                        </select>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="start-date">Start Date:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <mat-label>Enter start date</mat-label>
                        <input matInput [matDatepicker]="picker" [formControl]="date" readonly required/>
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <th id="role-header">Role:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <select matNativeControl [(ngModel)]="user.roles" name="role" id="role" required>
                            <option *ngFor="let role of roles" [value]="role.value">
                                {{role.displayValue}}
                            </option>
                        </select>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <button mat-raised-button color="primary" [disabled]="!form.form.valid">Submit</button>
    </form>
</mat-dialog-content>
<ng-template #deleteModal>
    <div class="center-text">
        <p>Are you sure you want to delete this employee?</p>
        <p><strong>{{employeeName}}</strong></p>
        <p><strong>{{this.selectedData.employeeGmin}}</strong></p>
        <br/>
    </div>
    <div class="center-text">
        <mat-dialog-actions align="end">
            <button mat-raised-button color="primary" (click)="deleteEmployee()">Yes
            </button>
            <button mat-raised-button (click)="close()">No
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>